module.exports = __webpack_public_path__ + "img/img.a5d57935.png";